import { useEffect } from 'react'
import { Button } from '@nextui-org/react'
import { useImpersonation } from '~/contexts/ImpersonationContext'

const IMPERSONATING_CLASS = 'impersonating'

/**
 * Fixed banner shown at the top of every page when a super admin is impersonating a user.
 * Toggles an `impersonating` class on <html> so global CSS can offset layouts.
 */
export function ImpersonationBanner() {
  const { isImpersonating, impersonatedUserEmail, impersonatedUserName, stopImpersonation } =
    useImpersonation()

  useEffect(() => {
    const el = document.documentElement
    if (isImpersonating) {
      el.classList.add(IMPERSONATING_CLASS)
    } else {
      el.classList.remove(IMPERSONATING_CLASS)
    }
    return () => el.classList.remove(IMPERSONATING_CLASS)
  }, [isImpersonating])

  if (!isImpersonating) {
    return null
  }

  const displayName = impersonatedUserName || impersonatedUserEmail

  return (
    <div className='fixed top-0 left-0 right-0 bg-warning-500 text-warning-foreground px-4 py-2 flex items-center justify-between z-[9999]'>
      <div className='flex items-center gap-2'>
        <svg
          className='w-5 h-5'
          fill='none'
          stroke='currentColor'
          viewBox='0 0 24 24'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M15 12a3 3 0 11-6 0 3 3 0 016 0z'
          />
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'
          />
        </svg>
        <span className='font-medium'>
          Impersonation Mode (Read-Only): Viewing as <strong>{displayName}</strong>
        </span>
      </div>
      <Button size='sm' color='default' variant='flat' onClick={stopImpersonation}>
        Exit to Super Admin
      </Button>
    </div>
  )
}
